
   export const getlovercase=(string) =>{
     return  string.replace(/\s+/g, '-').toLowerCase();
   }
 
   export const getuppercase=(string) =>{
    return  string.replace(/-/g, " ").toUpperCase();
  }

  export const removespecial=(string) =>{
    return  string.replace(/[^s+a-zA-Z0-9]/g, " ").toLowerCase();
  }

   export const isSticky = (e) => {
       const header = document.querySelector('.header-section'); 

        if(header!=null){
         const scrollTop = window.scrollY; 
        scrollTop >= 200  ? header.classList.add('is-sticky') : header.classList.remove('is-sticky');
    }
  };


    export const customStyles = {
      title: {
      style: {
          fontColor: 'red',
          fontWeight: '900',
      }
      },
      rows: {
      style: { 
          background:'#fff',
          minHeight: '58px',
          paddingLeft: '5px'
      }
      },
      headCells: {
      style: {
          background:'#f9fbfe',
          fontSize: '15px',
          fontWeight: '500',
          fontWeight:'bold',
          textTransform: 'uppercase',
          paddingLeft: '20px'
      },
      },
      cells: {
      style: {
          fontSize: '14px',
          paddingLeft: ' 10px',
        },
      },
    };


    export const getKey=(index,currentPage,perPage) =>{
      return  (index+1+currentPage*perPage)-perPage;
    }

 

    export const  getAge = (dateString)=>{
      var today = new Date();
      var birthDate = new Date(dateString);
      var age = today.getFullYear() - birthDate.getFullYear();
      var m = today.getMonth() - birthDate.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
          age--;
      }
      return age;
  }


  export const maxString=(string) =>{

    let value=",";

      if(string.length<20){
          value = string
          }else{
          value = string.substring(0, 20)+'...'  
      }

    return  value;
  }


   export const maxStringNew=(string) =>{

    let value=",";

      if(string.length<22){
          value = string
          }else{
          value = string.substring(0, 22)+'...'  
      }

    return  value;
  }




  export const getSeason=() =>{

     let element = [];

      for (let index = 1; index <= 20; index++) {  
          element.push(index);
      }

    return element
  }



  export const getAlpha=() =>{
    return  ["A","B","C","D","E","F","G","H","I","J","K","L","M","N","O","P","Q","R","S","T","U","V","W","X","Y","Z"];
  }

  

  
  